import {Injectable} from '@angular/core';
import {RequesterService} from "../../../shared/services/requester/requester.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {BehaviorSubject, map} from "rxjs";
import {CheckHistoryMapper} from "./performance-history/check-history-mapper";
import {PerformanceTestMapper} from './performance-test/performance-test-mapper';
import {DbStoreState} from '../../../store/reducers';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
@Injectable()
export class PerformanceService {

  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe( workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }

  public getConflictingPlugins(websiteId): BehaviorSubject<DbResponse> {
    return this._requester.performance.get(`workspaces/${this.currentWorkspaceId}/domains/${websiteId}/get-incompatible-active-plugins`);
  }

  public runPerformanceScan(websiteId: number, formData: any = null): BehaviorSubject<DbResponse> {
    const data = formData ? {"relativeUrl": formData ? formData : null} : null;
    return <BehaviorSubject<DbResponse>>(this._requester.performance
      .post(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}`, null, data)
      .pipe(map((response: DbResponse): DbResponse => {
        if (response && response.success) {
          response.data = PerformanceTestMapper.map(response.data);
        }

        return response;
      })));
  }

  public getPerformanceHistory(websiteId: number): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.performance
      .get(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/history`, null, true)
      .pipe(map((response: DbResponse): DbResponse => {
        if (response && response.success) {
          response.data = response.data.map(CheckHistoryMapper.map);
        }

        return response;
      })));
  }

  public getPerformanceTest(websiteId: number, performanceTestId: string): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.performance
      .get(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/${performanceTestId}`)
      .pipe(map((response: DbResponse): DbResponse => {
        if (response && response.success) {
          response.data = PerformanceTestMapper.map(response.data);
        }
        return response;
      })));
  }


  public runWarmUpPerformance(websiteId: number) {
    return this._requester.performance
      .post(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/warmup`, null, null, true);
  }

  public setSchedulePerformance(websiteId: number, data) {
    return this._requester.performance
      .post(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/schedule`, null, data, true);
  }

  public getSchedulePerformance(websiteId: number) {
    return <BehaviorSubject<DbResponse>>(this._requester.performance
      .get(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/schedule`, null, true)
      .pipe(map((response: DbResponse) => {
        return response;
      })));
  }

  public getGooglePageSpeedScore (websiteId: number) {
    return this._requester.performance
      .post(`workspaces/${this.currentWorkspaceId}/performance/${websiteId}/googlepagespeed`, null, null, true);
  }

  public getConnectionFlowProgress (websiteId: number) {
    return this._requester.performance.get(`workspaces/${this.currentWorkspaceId}/domains/${websiteId}/get_connection_flow_progress`);
  }

  public setBoosterNpsData(websiteId: number, data) {
    return this._requester.performance
      .post(`workspaces/domains/${websiteId}/set-nps-data`, null, data, true);
  }

  public getBoosterNpsData(websiteId: number) {
    return this._requester.performance.get(`workspaces/domains/${websiteId}/get-nps-data`);
  }

  public postOptimizationTasks (websiteId: number, flowId: any) {
    const data: object = {
      flow_id: flowId
    };

    return this._requester.performance.post(`workspaces/performance/${websiteId}/post-optimization-tasks`, null, data);
  }

  public setNotOptimizedScore (websiteId: number, flowId: any) {
    const data: object = {
      flow_id: flowId
    };

    return this._requester.performance.post(`/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/set_nooptimize_score`, null, data);
  }

  public createTestCdnPage (websiteId: number, siteUrl) {
    const data = {
      "originalSiteUrl": siteUrl
    };
    return this._requester.performance.post(`/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/ttfb`, null, data);
  }

  public getTestCdnPage (websiteId: number) {
    return this._requester.performance.get(`/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/ttfb`, null, true);
  }

  public generateTestCdnPage (websiteId: number, siteUrl, mode = 'default') {
    const data = {
      "siteurl": siteUrl,
      "mode": mode
    };
    return this._requester.optimizerDemo.post(`/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/demo-optimize-website`, null, data);
  }

  public removeTestCdnPage (websiteId: number) {
    return this._requester.performance.delete(`/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/ttfb`, null, null);
  }
}
